import { DeleteOutlined, DownloadOutlined, DownOutlined, EditOutlined, EyeOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, ConfigProvider, Input, Pagination, Select } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import * as typeVehicleApi from '../../../api/typeVehicle/typeVehicleApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import useDebounce from '../../../hook/useDebounce';
import useToast from '../../../hook/useToast';
import Layout from '../../../Layout';
import './style.scss';

import viVN from 'antd/locale/vi_VN';
import { API_URL } from '../../../env';
import useThrottle from '../../../hook/useThrottle';

import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { PaginationProps } from 'antd/es/pagination/Pagination';
import { useSelector } from 'react-redux';
import { noData } from '../../../components/ExportImgFigma';
import useLoading from '../../../hook/useLoading';
import { selectorMenu } from '../../../store/slices/menuSlice';
import { dataPagination, findChildIdByUrl, getWidthFromHeader } from '../../../until';
import ImportDataColorCar from '../../Customers/Component/ImportDataModal/ImportDataColorcar';
import StatusCellRenderer from '../VehicleTypeManagement/Component/StatusCellRenderer';
import ModalCreateVersionCar from './component/modal/ModalCreateVersionCar';
import ModalEditVersionCar from './component/modal/ModalEditVersionCar';
import ModalViewVersionCar from './component/modal/ModalViewVersionCar';
import { getInfoVersionCar, getListVersionCar, ICarVersion, updateActiveVersion } from '../../../api/carVersion/carVersionApi';
import { NodataTable } from '../../../components/NoDataTable';
import { formatNumber } from '../../../services/mixin';

interface IDataDefaulFilterList {
  searchNameVersion?: string,
  carLineId?: number,
  typeVehicleId?: number,
  carVersionId?: number,
  modelVehicleId?: number
}
const dataDefaulFilterList: IDataDefaulFilterList = {

};

const VehicleVersionManagement: React.FC = () => {
  useEffect(() => {

    return () => {
      setDataFilterList(dataDefaulFilterList)
      setPagination({ current: 1, pageSize: 20, total: 0 })
      setSelectedRowKeys([])
    }
  }, [])

  const pushToast = useToast();
  const pushLoading = useLoading()
  const menuSlice = useSelector(selectorMenu)
  const { add, edit, delete: isdelete, download, upload } = findChildIdByUrl(menuSlice, "/vehicle-management/vehicle-model-management")

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [openModalUpload, setOpenModalUpload] = useState(false);
  const [fileData, setFileData] = useState({} as any)
  const [type, setType] = useState<string>("")

  const [isOpenModalAdd, setIsOpenModalAdd] = useState(false)
  const [isOpenModalView, setIsOpenModalView] = useState(false)
  const [isOpenModalEdit, setIsOpenModalEdit] = useState(false)
  const [isOpenModalDelete, setIsOpenDelete] = useState(false)

  const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const [infoCarVersion, setInfoCarVersion] = useState<ICarVersion>()

  const [listCarVersion, setListCarVersion] = useState<ICarVersion[]>([])

  const actionColumn: ColDef = {
    headerName: 'Hành động',
    field: 'action',
    colId: 'action',
    width: 180,
    suppressMovable: true,
    lockPosition: 'left',
    cellRenderer: (params: any) => {
      const id = params.data.id
      const groupPermissionId = params.data.permissionMenu?.groupPermissionId
      // const { view, edit, delete: isDelete } = params?.data?.permissionMenu
      return (
        <div className='d-flex gap-4 justify-start align-center  h-full'>

          <EyeOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
            onClick={() => setIsOpenModalView(true)}
          />
          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
            onClick={() => setIsOpenModalEdit(true)}
          />
          <DeleteOutlined
            className={`text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
            onClick={() => openModalDelete(Number(undefined))}
          />

        </div>

      )
    },
    flex: 1
  }

  const columnDefs = useMemo<ColDef<any>[]>(() =>
    [
      actionColumn,
      {
        headerName: "Dòng xe",
        field: "carLineTitle"
      },
      {
        headerName: "Loại xe",
        field: "typeVehicleTitle"
      },
      {
        headerName: "Danh mục xe",
        field: "categoryCarTitle"
      },
      {
        headerName: "Mẫu xe",
        field: "modelVehicleTitle"
      },
      {
        headerName: "Mã phiên bản",
        field: "code"
      },
      {
        headerName: "Tên phiên bản",
        field: "title"
      },
      {
        headerName: "Năm SX",
        field: "carYear"
      },
      {
        headerName: "Trạng thái",
        field: "status",
        sortable: true,
        cellRenderer: StatusCellRenderer,
        cellRendererParams: {
          onToggle: (id: number, isActive: boolean) => uActiveCarVersion(id, isActive),
          idKey: 'id',
        },
        width: 180
      },
    ], []);


  const gListCarVersion = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const {
      searchNameVersion, carLineId, typeVehicleId, carVersionId, modelVehicleId
    } = dataFilterList

    const result = await getListVersionCar(
      pageSize, pageCurent, searchNameVersion, carLineId,
      typeVehicleId, carVersionId, modelVehicleId
    )
    if (result?.status) {
      setListCarVersion(result.data)
      setPagination({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const gInfoCarVersion = useThrottle(async (id: number, isview: boolean = true) => {
    pushLoading(true)
    const result = await getInfoVersionCar(
      id
    )
    if (result?.status) {
      setInfoCarVersion(result.data)
      if (isview)
        setIsOpenModalView(true)
      else
        setIsOpenModalEdit(true)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const uActiveCarVersion = useThrottle(async (id: number, isActive: boolean) => {
    pushLoading(true)
    const result = await updateActiveVersion(
      id
    )
    if (result?.status) {
      gListCarVersion(pagination.current, pagination.pageSize)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)


  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    // if (iSsuccess) {
    //   setIsOpenModalAdd(false)
    //   pushToast(message, "success")
    //   gListCarLine()
    // } else {
    //   pushToast(message, "error")
    // }
  }

  const onSubmitFormModalEdit = (iSsuccess: boolean, message?: string) => {
    // if (iSsuccess) {
    //   setIsOpenModalEdit(false)
    //   pushToast(message, "success")
    //   gListCarLine()
    // } else {
    //   pushToast(message, "error")
    // }
  }

  const onSubmitFormModalDelete = async () => {
    // if (!idChose) return
    // const result = await deleteCarLines(idChose)
    // if (result.status) {
    //   setIsModalDelete(false)
    //   pushToast(result.message, "success")
    //   gListCarLine()
    // } else {
    //   pushToast(result.message, "error")
    // }
  }

  const onConfirmDelete = async () => {
    // const result = await customerApi.deleteCustomer(idCustomer)
    // if (result?.status) {
    //   gListCustomer(pagination.current, pagination.pageSize)
    //   pushToast(result.message, "success")
    //   closeModalDelete()
    //   closeModalDeleteMore()
    //   setSelectedRowKeys([])
    // } else {
    //   pushToast(result?.message, "warning")
    // }
  }

  const openModalDelete = (id: number) => {
    // setIdCustomer(id)
    setIsOpenDelete(true)
  }


  const closeModalDelete = () => {
    // setIdCustomer(undefined)
    setIsOpenDelete(false)
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListCarVersion(pageNumber, pageSize)
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleUpload = async (type: string) => {
    // const handleUpload = async (type: string): Promise<typeVehicleApi.ResponseSuccessDataError> => {
    // setType(type)
    // const result = await typeVehicleApi.uploadFileCarVersion(fileData)
    // if (result?.status) {
    //   pushLoading(true)
    // }
    // return result
  }
  const handleFile = (file: any) => {
    setFileData(file)
  }

  useEffect(() => {
    gListCarVersion()
  }, [dataFilterList])

  return (

    <Layout>
      <ModalCreateVersionCar
        isOpen={isOpenModalAdd}
        // onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setIsOpenModalAdd(false)}
      />

      <ModalViewVersionCar
        isOpen={isOpenModalView}
        closeModal={() => setIsOpenModalView(false)}
      />

      <ModalEditVersionCar
        isOpen={isOpenModalEdit}
        infoCarVersion={infoCarVersion}
        // onSubmitFormModal={onSubmitFormModalEdit}
        closeModal={() => setIsOpenModalEdit(false)}
      />

      <ModalDeleteManager
        isOpen={isOpenModalDelete}
        title="Bạn có chắc chắn xóa mẫu xe này"
        titleDelete="Xóa mẫu xe"
        content="Mẫu xe và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
        onConfirm={onConfirmDelete}
        closeModal={closeModalDelete}
      />

      {/* <ImportDataColorCar
        show={openModalUpload}
        fileData={fileData}
        linkExamplPre={`${API_URL}uploads/fileExcel/car/Danhsachthuonghieu.xlsx`}
        type={"dataCategoryError"}

        setFileData={setFileData}
        handleUpload={() => handleUpload(type)}
        handleFile={handleFile}
        gListCarColor={gListCarVersion}
        modalClose={() => setOpenModalUpload(false)}
      /> */}
      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Quản lý xe</a>,
          },
          {
            title: 'Quản lý phiên bản xe',
          },
        ]}
      />
      <div className='title-page'>
        Quản lý phiên bản xe
      </div>
      <div className='d-flex gap-3 pb-18-px brand-management-filter'>
        <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
          <Input
            placeholder="Tìm kiếm theo phiên bản xe"
            className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
            value={dataFilterList.searchNameVersion}
            onChange={(e) => setDataFilterList({ ...dataFilterList, searchNameVersion: e.target.value })}
          />
          <div className=" border-l-F2F4F7 h-full d-flex align-center">
            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
          </div>
        </div>



        <div className='d-flex align-center gap-2'>
          <div className="w-200-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
            <div className="d-flex align-center  w-full">
              <Select
                showSearch
                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                popupClassName='position-dropdow custome-select-item h-popUp'
                variant="borderless"
                placeholder="Chọn bộ lọc"
                suffixIcon={null}
                options={[]}
              // value={filterSort}
              // onChange={(e) => setFilterSort(e)}
              />

            </div>
            <div className="  h-full d-flex align-center">
              <DownOutlined className="text-sm text-98A2B3 " />
            </div>
          </div>
        </div>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-106-px py-2 px-4 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${!download && "disabled"}`}
        // onClick={selectedRowKeys.length ? glistSelectedExel : glistByExcel}
        >
          <DownloadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Xuất DS</span>
        </button>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-111-px py-2 px-4 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${!upload && "disabled"}`}
          onClick={() => setOpenModalUpload(true)}
        >
          <UploadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Nhập DS</span>
        </button>
        <button className={`border-none bg-096DD9 rounded-6-px  py-2 px-4 h-8 d-flex justify-center align-center gap-10-px w-107-px ${!add && "disabled"}`}
          onClick={() => setIsOpenModalAdd(true)}
        >
          <PlusOutlined className='text-sm text-white' />
          <span className='text-sm fw-400 font-regular text-white white-space-nowrap'>Tạo mới</span>
        </button>
      </div>
      <div className="t-table-block  custom-page-css flex flex-col flex-1 justify-between">
        <div className="ag-theme-alpine custom-table-ag custom-brand-table" style={{ width: '100%' }}>
          <AgGridReact
            rowSelection="multiple"
            rowData={listCarVersion}
            columnDefs={columnDefs}
            domLayout="autoHeight"
            className="my-auto-height-grid"
            rowHeight={55}
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}

            />
          </div>
        </ConfigProvider>
      </div>
    </Layout>

  );
}

export default VehicleVersionManagement;
